const DEVICE_ID_STORAGE_KEY = "zapido_device_id";
const DEVICE_ID_REGEX = /^[a-zA-Z0-9_-]{16,128}$/;

function generateDeviceId(): string {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID().replace(/-/g, "");
  }

  const randomPart = Math.random().toString(36).slice(2);
  const timestampPart = Date.now().toString(36);
  return `${timestampPart}${randomPart}`.slice(0, 32);
}

export function getOrCreateDeviceId(): string | null {
  if (typeof window === "undefined") return null;

  try {
    const existing = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (existing && DEVICE_ID_REGEX.test(existing)) {
      return existing;
    }

    const generated = generateDeviceId();
    window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, generated);
    return generated;
  } catch (error) {
    console.warn("Unable to access localStorage for device id:", error);
    return null;
  }
}
